import { Component } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-invalid-user',
  imports: [],
  templateUrl: './invalid-user.html',
  styleUrl: './invalid-user.scss',
})
export class InvalidUser {

  constructor(private auth: AuthService) {  }

  ngOnInit() : void
  {
  }

}
